import React from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  CardHeaderActions,
  CardTitle,
} from 'components/Card'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import { JobCardEmptyState } from '../JobCardEmptyState'
import Button from 'components/Button'
import AmendmentsTable from './AmendmentsTable'
import styles from './AmendmentsCard.sass'
import Tooltip from 'components/Tooltip'

interface Props {
  vm: JobViewModel
}

export default observer(function AmendmentsCard({ vm }: Props) {
  return (
    <div className={styles.root}>
      <Card>
        <CardHeader>
          <CardTitle>Amendments</CardTitle>
          <CardHeaderActions>
            {!vm.completed && (
              <Tooltip content="Add an amendment">
                <IconButton
                  onClick={vm.createAmendmentVM.show}
                  data-test="add-amendment-button"
                >
                  <Icon name="add" />
                </IconButton>
              </Tooltip>
            )}
          </CardHeaderActions>
        </CardHeader>
        <CardContent scroll compact>
          {vm.canViewAmendments && vm.job.amendments.length ? (
            <AmendmentsTable vm={vm.detailsVM.amendmentsTableVM} />
          ) : (
            <div className={styles.emptyStateBottomPadding}>
              <JobCardEmptyState
                helpText={
                  'Whether the client is requesting a refund, additional or reduced services, or the Pro is requesting additional earnings, you can make amendments to the job here.'
                }
              >
                {!vm.completed && (
                  <Button
                    onClick={vm.createAmendmentVM.show}
                    data-test="add-amendment-button"
                    type="text"
                  >
                    Add an amendment
                  </Button>
                )}
              </JobCardEmptyState>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
})
